import React, { useState } from 'react'
import {
  Box,
  Typography,
  Chip,
  Tooltip,
} from '@mui/material'
import { usePermissions } from '../../hooks/usePermissions'
import { shouldUseNewPermissions } from '../../utils/devMode'

const UserRoleIndicator = () => {
  const { userRole, permissions } = usePermissions()
  const useNewPermissions = shouldUseNewPermissions()
  const [showTooltip, setShowTooltip] = useState(false)

  // Показываем только если включена новая система прав
  if (!useNewPermissions || !userRole) {
    return null
  }

  const getRoleColor = (role) => {
    switch (role) {
      case 'admin':
        return '#f44336' // Red
      case 'user':
        return '#2196f3' // Blue
      case 'viewer':
        return '#9e9e9e' // Grey
      case 'driver':
        return '#ff9800' // Orange
      case 'picker':
        return '#4caf50' // Green
      default:
        return '#9e9e9e'
    }
  }

  const getRoleLabel = (role) => {
    switch (role) {
      case 'admin':
        return 'Administrator'
      case 'user':
        return 'User'
      case 'viewer':
        return 'Viewer'
      case 'driver':
        return 'Driver'
      case 'picker':
        return 'Picker'
      default:
        return role
    }
  }

  const getPermissionsCount = () => {
    if (!permissions || !permissions.actions) return 0

    let count = 0
    Object.values(permissions.actions).forEach((module) => {
      if (typeof module === 'object') {
        Object.values(module).forEach((action) => {
          if (typeof action === 'object') {
            Object.values(action).forEach((permission) => {
              if (permission === true) count++
            })
          } else if (action === true) {
            count++
          }
        })
      }
    })
    return count
  }

  return (
    <Tooltip
      title={
        <Box sx={{ padding: '8px' }}>
          <Typography
            variant='body2'
            sx={{ fontWeight: 'bold', marginBottom: '4px' }}
          >
            Role: {getRoleLabel(userRole)}
          </Typography>
          <Typography
            variant='body2'
            sx={{ marginBottom: '4px' }}
          >
            Permissions: {getPermissionsCount()} active
          </Typography>
          <Typography
            variant='caption'
            sx={{ color: '#ccc' }}
          >
            Click to view details
          </Typography>
        </Box>
      }
      open={showTooltip}
      onOpen={() => setShowTooltip(true)}
      onClose={() => setShowTooltip(false)}
      placement='bottom'
    >
      <Chip
        label={getRoleLabel(userRole)}
        size='small'
        sx={{
          backgroundColor: getRoleColor(userRole),
          color: 'white',
          fontWeight: 'bold',
          fontSize: '11px',
          height: '24px',
          cursor: 'pointer',
          '&:hover': {
            opacity: 0.8,
          },
        }}
        onClick={() => setShowTooltip(!showTooltip)}
      />
    </Tooltip>
  )
}

export default UserRoleIndicator
